import React from 'react';
import '../css/Counseling.css';

const Counseling = () => {
	return (
		<section className='Counseling'>
			<div className='counseling-container container padding'>
				<h1>
					Sé un <span>profesional</span>
					<br /> en menos de un año
					<span>.</span>
				</h1>
				<div className='counseling-content'>
					<p>Estudia online desde cualquier parte del mundo con FEEDBACK en vivo y en Discord.</p>
					<a
						href='https://calendly.com/libel/charla-informativas-personalizadas'
						// target={'_blank'}
						rel='noreferrer'
						className='agenda'
					>
						MÁS INFORMACIÓN
					</a>
				</div>
			</div>
		</section>
	);
};

export default Counseling;
